<template>

    <div class="has-margin-top">
        <div class="bp-panel is-form has-no-title" style="min-height: auto">
            <div class="panel-content is-table-form">
                <catalog-settings-input
                    :years="item.years || []"
                    :catalogPage="item.catalogPage || ''"
                    :catalogSettings="item.catalogSettings || []"
                    @change="saveChange"
                />
            </div>
        </div>
    </div>

</template>

<script>

import Mixin from '../../tab';
import CatalogSettingsInput from "@components/form/CatalogSettingsInput";

export default {
    mixins: [ Mixin ],

    props: {
        component: {
            type: Object,
            required: true,
        },
    },

    methods: {
        saveChange: function (key, value) {
            this.$emit('saveItemDebounce', key, value);
            this.$store.commit('updateData', {[key]: value});
        },
    },

    components: {
        CatalogSettingsInput,
    },
}
</script>
